import type { FormItemError, Tournament, TournamentTeam } from '@/services/api'
import { api } from '@/services'
import { useGlobalStore } from '@/stores/global'

export interface TournamentFormParticipantError {
  item: FormItemError
  participantId: number
  participantName: string
}

export function formattedDraftExpiry(date: string) {
  if (date) {
    const d = new Date(date)
    return d.toLocaleString('en-CA')
  }
  return ''
}

export async function getTeamRegistrationProgress(teamId: number) {
  const globalStore = useGlobalStore()
  if (!teamId) {
    return
  }
  try {
    globalStore.incrementLoading()
    const result = await api.api.getTournamentTeamRegistration(teamId)

    // @ts-expect-error the double .data is an artifact of the api autogeneration
    if (result.status === 200 && result.data && result.data.data) {
      // @ts-expect-error as above
      return result.data.data
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }

  return undefined
}

export async function saveTeamRegistrationProgress(teamId: number, registrationData: string) {
  const globalStore = useGlobalStore()
  if (!teamId) {
    return
  }
  try {
    globalStore.incrementLoading()
    await api.api.storeTournamentTeamRegistration(teamId, {
      data: registrationData
    })
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return
}

export async function getAccountTournamentTeams(tournamentId: number) {
  const globalStore = useGlobalStore()

  let list: TournamentTeam[] = []
  if (!tournamentId) {
    return list
  }
  try {
    globalStore.incrementLoading()

    const teamData = await api.api.getTournamentTeams(tournamentId).then((res) => res.data)
    if (teamData?.data) {
      list = teamData.data
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return list
}

export async function getTournamentTeam(id: number) {
  const globalStore = useGlobalStore()

  let team = undefined
  if (!id) {
    return team
  }
  try {
    globalStore.incrementLoading()
    const teamData = await api.api.getTournamentTeamById(id).then((res) => res.data)
    if (teamData?.data) {
      team = teamData.data
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return team
}

export async function getTournament(id: number): Promise<Tournament | undefined> {
  const globalStore = useGlobalStore()

  let tournament = null
  if (!id) {
    return tournament
  }
  try {
    globalStore.incrementLoading()
    const tournamentData = await api.api.getTournamentById(id).then((res) => res.data)
    if (tournamentData?.data) {
      tournament = tournamentData.data
    }
  } catch (error) {
    console.error(error)
  } finally {
    globalStore.decrementLoading()
  }
  return tournament
}

// async function fetchTournamentClubs() {
//   const id = Number.parseInt(tournamentId.value)
//
//   // if we are already fetching a new tournament wait
//   while (isFetching.value) {
//     await new Promise((resolve) => setTimeout(resolve, 10))
//   }
//
//   // if we can not get an id, or the current retrieved tournament is the same as the one requested: return
//   if (!id || id == tournament.value?.id) {
//     return
//   }
//
//   isFetching.value = true
//   try {
//     if (tournament.value && tournament.value?.id === id) {
//       const clubs = await getTournamentTeams(id)
//       console.log(clubs)
//       tournament.value.clubs = clubs
//     }
//   } catch (error) {
//     console.error('Failed to fetch tournament:', error)
//   } finally {
//     // Fetch complete
//     isFetching.value = false
//   }
// }
